import { FreightTypeEntity } from "@ots-frontend/ots-data";
import { useCallback, useEffect, useState } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseFreightTypeSelectProps = Omit<
  BaseEntitySelectProps<FreightTypeEntity>,
  'nameMapper'
> & {
  useAbbreviation?: boolean;
};

export const BaseFreightTypeSelect = (props: BaseFreightTypeSelectProps) => {
  const { useAbbreviation = true, entities, ...rest } = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback(
    (e: FreightTypeEntity) => {
      if (useAbbreviation) {
        return e.abbr ?? e.name;
      } else {
        return e.name;
      }
    },
    [useAbbreviation]
  );

  // sort freight types by display name
  useEffect(() => {
    if (entities) {
      const sortedFreightTypes = entities.sort((a, b) =>
        nameMapper(a).localeCompare(nameMapper(b))
      );
      setSortedData(sortedFreightTypes);
    }
  }, [entities, nameMapper]);

  return (
    <BaseEntitySelect entities={sortedData} nameMapper={nameMapper} {...rest} />
  );
};
